import classNames from "classnames";
import React, { useState } from "react";

export function SeshTextRawInput(
	props: {
		right_children?: (
			is_hovered: boolean,
			is_focused: boolean
		) => JSX.Element;
	} & React.HTMLProps<HTMLInputElement>
) {
	const [is_focused, setIsFocused] = useState(false);
	const [is_hovered, setIsHovered] = useState(false);

	const { right_children, ...input_props } = props;

	// TODO: handle focus on that child input
	return (
		<div
			className={classNames(
				"flex h-10 rounded-[4px] border-2  bg-base-dark text-content-primary outline-none ",
				props.className,
				{
					"input-disabled": props.disabled,
					"border-sesh-primary shadow-input-focus": is_focused,
					"border-content-secondary hover:border-sesh-dark":
						!is_focused,
				}
			)}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<input
				{...input_props}
				className="w-full border-none bg-transparent px-[11px] py-[7px] outline-none"
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				type="text"
				value={props.value ?? ""}
				placeholder={props.placeholder}
				maxLength={props.maxLength}
				onChange={props.onChange}
			></input>
			{right_children && (
				<div className="ml-auto">
					{right_children(is_hovered, is_focused)}
				</div>
			)}
		</div>
	);
}
